import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getListProduct(params) {
	return client.get("product/list", {
		params: params,
	});
}

function getListProductPremium(params) {
	return client.get("product/premium/list", {
		params: params,
	});
}

function getDetailProduct(params) {
	return client.get("product/detail", {
		params: params,
	});
}

function addTransactionProduct(params) {
	return client.post("transaction/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function checkSerialRO(params) {
	return client.post("transaction/check/serial", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function checkSerialROPremium(params) {
	return client.post("transaction/check/serial/premium", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function addROProduct(params) {
	return client.post("transaction/repeatorder", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function addROProductPremium(params) {
	return client.post("transaction/repeatorder/premium", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getListTransaction(params) {
	return client.get("transaction/list", {
		params: params,
	});
}

function getDetailTransaction(params) {
	return client.get("transaction/detail", {
		params: params,
	});
}

export default {
	getListProduct,
	getListProductPremium,
	getDetailProduct,
	addTransactionProduct,
	checkSerialRO,
	checkSerialROPremium,
	addROProduct,
	addROProductPremium,
	getListTransaction,
	getDetailTransaction,
};